import store from '@/store'

export default class Planting {
  constructor(remotePlanting) {
    this.id = remotePlanting.id
    this.username = remotePlanting.username
    this.fieldIds = remotePlanting.fieldIds
    this.masterCropId = remotePlanting.masterCropId
    this.cropName = remotePlanting.cropName
    this.varietyName = remotePlanting.varietyName
    this.colorHex = remotePlanting.colorHex
    this.startDate = remotePlanting.startDate
    this.endDate = remotePlanting.endDate
    this.now = remotePlanting.now

    this.fieldNames = remotePlanting.fieldNames
    this.fieldArea = remotePlanting.fieldArea
  }

  getLongDisplayText(opts = { includeYear: true }) {
    let text = ''
    if (opts.includeYear) {
      text = this.startDateYear + ' '
    }

    // カスタム作物名が登録されていたら、それが表示で優先される
    if (this.cropName) {
      text += this.cropName
    } else {
      const growCrops = store.getters.growCrops
      const masterCropId = this.masterCropId
      const matched = growCrops.find(c => c.masterId === masterCropId)
      if (matched) {
        text += matched.localizedName
      }
    }

    // 品種名があったら表示
    if (this.varietyName) {
      text += ' / ' + this.varietyName
    }
    return text
  }

  get startDateYear() {
    if (this.startDate) {
      return this.startDate.split('-')[0]
    }
    return null
  }

  get duration() {
    let value = this.startDate + ' - '
    if (this.endDate) {
      value += this.endDate
    } else {
      value += 'now' // FIXME
    }
    return value
  }

  get fieldsCount() {
    if (this.fieldIds) {
      return this.fieldIds.length
    }
    return 0
  }

  static listCurrentForField(field) {
    return Planting.listForField(field).filter(p => p.now)
  }

  static listPastForField(field) {
    return Planting.listForField(field).filter(p => !p.now)
  }

  static listForField(field) {
    if (field) {
      return store.getters.plantings.filter(p => {
        if (p.fieldIds) {
          return p.fieldIds.includes(field.id)
        }
      })
    }
    return []
  }

  static listForFieldAndDate(field, momentDate) {
    return Planting.listForField(field).filter(p => {
      let endDate = null
      if (p.endDate) {
        endDate = p.endDate
      } else {
        endDate = '9999-12-31'
      }
      if (momentDate.isSameOrAfter(p.startDate)) {
        if (momentDate.isSameOrBefore(p.endDate)) {
          return true
        }
      }
      return false
    })
  }
}
